import React, { useState, useEffect } from 'react';
import { Megaphone } from 'lucide-react';

const TopAnnouncementBar = () => {
  const [announcements, setAnnouncements] = useState([]);

  // 获取动态公告
  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch('/testapi/user/user_controller/web_info', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();

        if (data.code === "0" && data.info) {
          console.log('TopAnnouncementBar: 获取到动态公告:', data.info);

          // 按 ｜ 分割公告内容
          const dynamicInfos = data.info.split('｜').filter(item => item.trim());
          setAnnouncements(dynamicInfos.map(info => info.trim()));
        } else {
          console.log('TopAnnouncementBar: 无公告内容');
          setAnnouncements([]);
        }
      } catch (error) {
        console.error('TopAnnouncementBar: 获取公告失败:', error);
        setAnnouncements([]);
      }
    };

    // 立即获取一次
    fetchAnnouncements();

    // 每5分钟刷新一次
    const intervalId = setInterval(fetchAnnouncements, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  // 如果没有公告，则不显示
  if (announcements.length === 0) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-100 text-gray-700 shadow-sm border-b border-gray-200 relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-100/30 to-indigo-100/30"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-3">
        <div className="flex items-center gap-3">
          {/* 左侧图标 */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-7 h-7 bg-blue-500/20 rounded-full flex items-center justify-center">
              <Megaphone className="w-4 h-4 text-blue-600" />
            </div>
            <span className="font-medium text-sm text-gray-600 hidden sm:block">系统公告</span>
          </div>

          {/* 静态显示公告内容 - 不滚动 */}
          <div className="flex-1 flex items-center gap-2">
            <span className="text-sm font-medium text-gray-700">
              {announcements.length > 1
                ? announcements.join(' • ')
                : announcements[0] || '暂无公告'
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopAnnouncementBar;